









import { Component, Prop, Vue } from 'vue-property-decorator';
import HeaderNavbar from '@/components/Header/Navbar.vue';
import PlantList from '@/components/PlantList/index.vue';

@Component({
  components: {
    HeaderNavbar,
    PlantList
  }
})
export default class Plants extends Vue {}
